import { render, staticRenderFns } from "./ProjectTaskTemplateEditForm.vue?vue&type=template&id=7d0660fb&"
import script from "./ProjectTaskTemplateEditForm.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskTemplateEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports